import authReducer from './slices/authSlice';
import binReducer from './slices/binSlice';

export const reducers = {
  auth: authReducer,
  bin: binReducer,
};
